import { render } from "./ServicesTemplate.vue?vue&type=template&id=2e3d0db4"
import script from "./ServicesTemplate.vue?vue&type=script&lang=js"
export * from "./ServicesTemplate.vue?vue&type=script&lang=js"

import "./ServicesTemplate.vue?vue&type=style&index=0&id=2e3d0db4&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__